<div class="tw-border tw-border-solid tw-border-primary-orange tw-rounded-lg
            tw-text-center tw-px-12 tw-py-16 tw-mt-8">
    <span class="tw-font-bold">{{message}}</span>
    <div class="tw-pt-4">
        <mb-link [useSlot]="true" [linkData]="{ url: allProductCategoriesUrl }">
            <span [innerHTML]="linkText"></span>
        </mb-link>
    </div>
</div>
